// extracted by mini-css-extract-plugin
module.exports = {"heroImage":"room__styles__heroImage___1owSKS","title":"room__styles__title___1gNzcS","content":"room__styles__content___3PfekL","ctas":"room__styles__ctas___Bc-5-e"};